<template>
    <div>
        <div class="insurance-filter">
            <div class="row">
                <div class="col-sm-2">
                    <label>{{ zipcodeLabel }}</label>
                    <zip-code-input
                        v-model="ZipCode"
                        :autofocus="true"
                        @input="getLocationByZip"
                    />
                    <span
                        v-show="ShowZipCodeError"
                        class="error-msg">Invalid Zipcode</span>
                </div>
                <div class="col-sm-3 col-lg-2">
                    <label>{{ insuredLabel }}</label>
                    <ul class="form-radio">
                        <li>
                            <input
                                id="insured-yes"
                                v-model="CurrentlyInsured"
                                type="radio"
                                name="insured-insurance"
                                value="Yes"
                            /> <label for="insured-yes">Yes</label>
                        </li>
                        <li>
                            <input
                                id="insured-no"
                                v-model="CurrentlyInsured"
                                type="radio"
                                name="insured-insurance"
                                value="No"
                            /> <label for="insured-no">No</label>
                        </li>
                    </ul>
                </div>
                <div class="col-sm-4 col-lg-5">
                    <label>{{ insuranceTypeLabel }}</label>
                    <ul class="form-radio">
                        <li>
                            <input
                                id="homeowners-only"
                                type="radio"
                                name="insured-type"
                                :value="InsuranceType"
                                :checked="!IsBundleSelected"
                                @change="IsBundleSelected = false; ProductType = getInsuranceType();"
                            /> <label for="homeowners-only">{{ InsuranceTypeDisplayName }}</label>
                        </li>
                        <li>
                            <input
                                id="insurance-bundle"
                                type="radio"
                                name="insured-type"
                                :value="BundleType"
                                :checked="IsBundleSelected"
                                @change="IsBundleSelected = true; ProductType = getInsuranceType();"
                            /> <label for="insurance-bundle">{{ BundleDisplayName }}</label>
                        </li>
                    </ul>
                </div>
                <div class="col-sm-3 col-lg-3 text-right">
                    <button
                        type="button"
                        class="btn btn-blue"
                        :disabled="ShowZipCodeError || ZipCode.length < 5"
                        @click="fetchInsuranceResult();">
                        Update results
                    </button>
                </div>
            </div>
        </div>
        <div class="insurance-results">
            <transition
                v-if="ShowLoader"
                name="fade">
                <div class="loader">
                    <img
                        alt="lt-loader"
                        width="60"
                        height="60"
                        src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAD0AAAA8CAYAAADVPrJMAAAAAXNSR0IArs4c6QAADJZJREFUaAXdWwtwVcUZ/nfPuffc5JKHgBDESkBR0VpRREWhBEJDo6A4TlIFywRQbEWccZSiaDu3voa21s5A1QoFEh6lhtYHKD5ISCoy+AIERitiykAECUoIuYTknnN2t9+eJBDIDbkhEXOzk9xz7p49u/+3/3P/3cvo+yrvqCDVVATJCF5KjjuEuBpMitKJsTRcg8RUEhE7ivtjIOEAkdpLxLcRE1vJsnbQgdoamtrzKNqrjiaRdWiHhQe7AdwAYr7hIDYLoG4gRuceH4Pp4fDfeAVirygJzE2wSXkEjz4gMt8lEiVkVO2m2/pXHe+nnTcdA7qwvDv5U24kV9xKnMZRINibXLseCDeIDBNkYqg6MJXJGpIUwVcXlXhIfgBMooRgPRSJaiHq2/v8eKfmMDpaCyl4HX1uoNxekIr2lfaBXgQRTTk8iTi7G2iuIiuBe2A1TRqsXfc1uPoRAH5KQu4kZlRCfGtwtcmxBRl+DoR+klAFzs4hyS7Gm1eQwYaS6b+wnvuQAhPgbUwik9tJqKVUkbqY7mOYjDMrZwRahcDP82jcu8kZD2f7X7tEWom9SIAoISQpeRjEr8J1NZnsvyCriiakVgM8qG+tKEbLKzGRLJVq+UVkqnGk2J0YrRcmkZNpEY9Uh2/uNv/ljNTlTzx0bVl5az1Ge95m0GoxdDSRZkMkZ9awoPmw8Xv3b8YM9B0pI0EFpMLLic4/QLlMy2j7SqGCuHzVnYyekCa6h1jCgCG+f1VkBZekci6rIAmP+YLhV0PXbNbGMObSJtBqBQ0kkxaCgJHeCCDpQ/eaz65nRfnkpOTTRPZdzCO3teErqofJDuZNTp7zcHq3sjTbMSBMygXwBYI7j88d8X7M4h4zaAC+lXz0J5iegeAowRjVgdt/oUpaxmaQFuPvvcC+89+tHzZCGImzuEk3a4MPoYe6q/cU4/f/YWTRjliIiAm0+gfdDmP0V9jZNA+woP0A/CC4/hrLJSjz2S1zijJ7kylnwAI8whnzcR/sZ0Rss5SZFxq17tPWqGkVNACPhzgvAEAdVGgOfwSH8wCbTB+21vn3+TxUkmE6jOdIRs8ZJkvTQKSjPou4bOKzY4q3n27s04KGSI+BSP8doPt5nbi0Bdc72R305ek6PZvP5pRmjoIrW2H4jD4KXFGO2sKI3/XUyKIWVQ4aEb3AG8JN0LPQ4X4ehx3ajut9nQmwpvyZjOISqdgMYcsKSKF2/VcLJebNXHtdcnRkMAzRHgBwEBx+Fjp8pRc3ufQVdPoOeMwfVKSj0arr5masfxWyPUm66pBwJWIZY0xSMDhn5tpsK9o7UUED8B3Q4Ts9o6WoBlNzPzjcorhE6/hs1z0zekOxYvIhKRD7CYWgjx5ITIwg/m9emoGGHmv9DUGUTYi2C5F5AnDXNX+189UcrUn4J+A+hwgYhp0lcEZzH12bfWLB00ByM9AAOhuc7QvICLLoDcDOZyGtLZ2/zL/prYjBnPnCkRu4AdiMBqmEyEOnUn4SaLWSMsHhXwAwI4cO4XMuXNPBU1/qzN+fHvleuSvoCSHVEcPkDNzOm108+oamNJ8EGg+mwnhhtYM7SevhmTc3bRwv97V1gfelIz8G04j7WS+m4/Ym5ThotYwuQaPheMZgwCoBegEb5dnuJs3j41aLuZTGQgQr1RwhG7id8fh/fjawkXoPNAItBpEeBqt9gQdT0WY2iYoaG8Xjde7oolWw4luFo7TvTpfkDmvEUc/pQtKOPFOLgxeIKFra2CBer4CCRZhajA/SrGaksmZ/MiZF46kHHaF01I5rEOZ9WPa/Ga9gm9IdYYdXA+BeiYBFKj5ehln/E6ADNIgsSm3gdBH1pOqmL8fr/Q3fDgzDiq/TeUh/gpFskDPYA60KYa8l9FlbbM13WG0sF9uf9egEM5WbuwqxGUBDvHWUBjm/ceaubItjNRyAHg/2QEPbEZxs6wT0dhgJzDB2uLaMKGQcwPEhfY84AQ7uItWIDCREAPzdhQmo7LARO0FHoo5XKZLbGRAD4qDwITsZGUZPl89p0Oc9AF3bCWjtMBJYd1UDT12m9RpBSkD6jPO0Fvf1RtCcJqoA5Ih310U+jh301cF7faP1WrtjpdgFGjRSrPj04Z/TEfw7XQSvB2Ne9lobQCv13gM4jUSi7M0pDLi19A0d9bh8COmDuFhRxcoYLyyxVU2kBknTOqp1pJliUrEfTEfhuLiQfL1T0cXKoQNYbWGpLLQMGwq31ToOY32wfwTQ1AP7F1rku1RxXOW3DOaXSJ26QlVxZBK/9Sy3Z8jUORBy7cK6TMlZdbkPMWj3enHWjJaHYcTNfUCos6e6Jg2fUZNp8ToLSeFUCy6rt7fwAGO5lHuxNeCrBuD6PSjF0slMSIhXgNHorpWBRMZVumeelXKFwwFahG2Id/0eEGP9yXCbJdKidRYvdZbJk+GyBmtRxoGHMlu5Rzjtw0Yc0VYPBNP5T+PqeAEUG53uQNPHk3XgrTjf4vREYMo262BEbWoIQ9GPzFQZXi40tj47catQKIRkkRrl7W7q7KhQGy//fFOk0T19AXdV4dHPkBlLQjzeBcr+PmsCJPlN2ogJVx1zyd0SCqHGwxa294DTbzR4aOi0dXsXwEy2PzkDq6tLdQ7cFbLESEr8SuPyQLNSBKGk1ntuy4vb6C69/Ix34FzxKQCNcAzoGL3V7/PrDh0H7YGT9gcAXeZB5Vhf3+K/JZ5B5y0ccz2A/tTjckRWMCU2Qse9dUWjThN7k/4H0KXasgN4CqzdPSonPqOznJwcgxnq18h59/KYKGlTfl7p8YzQcdAeVx2xCJAbtnHUjVRrnrQdEi+ct37+3Y/hocZ6XLZFGOuofIBvjERPXlywt91NOJxWgOhF4TAbLDj7rbol8bx4AavpnFY4truf81mmz+gNi62V+dWCKUWrm2I4mdP6iWk/B8i7vLDN5Bmk3BlqupdiaPpep713joqJOHiTI/U5PiUPHBP0tI5LmhLcDDRbDX8t1GNoFAFw/XwW7UuY0PSlzno/ZXHWaJOpJ0G/H+IssIR88uXpxV+eSm8z0F6DKvtNzM0CzwjgSC+Wn/PUBN+1p77cmb7nLcm6FAmB5+GiUrmJPLdLr1hBsTQajS36YjUBUZmw1iAaH+6JuqLdmIR72erIumgd/ZB10wpGX6sEWwCwVzIdiNhyB2KwrPwppVFPDEfnNBCw17CjxeSDEJUvPI5z6o/F+AvqZt+QHxLgqWNPLsi8GFL5guFjV2o6cQqh3FVyVkuA9fstgtYP2WrnEwC/G5zerb/Dol8E/71SjTezYBlalBKv7Vn4mLwoc5gpaAXj3GMEThdVQKwfWDa15N3TDR8T4SrbHInc6WLk0QZ4ok4KG3zqURxjWomgJuaDqKcjpC3Pfrk0K2gq+zYmjT8iyOyj/TE4/I2QbGbBtKJ/t9ZXTKB1J2p8wnCswudDx+v3vbxKHKJk9ny2Rv/04OyUyQUjfmII369gsKYDsKEBSyl3Kil/sziv5CR/3BJFMYPWHaixiX3Icp+Hw7/N69Bw6KActP9temSFKfnCSW9M2tXSQO2tf3Hci31TVNL0LcPfmXo4ff/5ZIN0/CkhiwUMbEHe+rJYx2gTaN2pZ9VdCwfOxWM2BYMfsonObj48wJVTjgX76zAqC/3+PTtzV4XsWIloqd1L01/ysW8D/f1C5CGOzjWlkf5dr69rPxuy0bITah0laF7ElX9eeW9pm86Ztxm0B1zP8Vgautc39PFS4/6hAdNMk0hA4ageMKtjUIMSpsxXTINtkiJSaVop1bmrclvdGFySsSQQPFclhcOqO6KqIT6DT8AWazYiqqCWY71GxE8/qj6/ZsPW8h/tfOrCve+V6qRAS5PWUv0ZgT7RmTKWTVg0HptEMzEPQwNGIMmVDjybDt1BoHDqsDzfjBw7VjjyCyb5PsnlUS5YBL/PENhRMaCbfrRPhJT0wVRehjw0FgtyqI/7u+FgK5wFzgBhTyLiRCIg9hNHipfS10xbOYoYNinOrLQTdP2ghTmF/mOR6usZM8aiw1v9hv9yKALAS49oPQHeSh7NbWwbSYmlAAwuJkQfgfFZBlLteFG31/96A12314DRfhdq13DJ37as4CZIDBIe7SsdArqRhFBI8Qu3LB+AXNRVJkdCjvgIQLkMkE/EAxgRQBtf0eqg56dp0aeCdsEmb5SMredSfVxmle8OdYCNaBzkxOiNNR10nZc9z+rBeySGWbhnIreuALKrwL5+hmRpilM3cC+JKfzskMEGSKqQTO3BCaBthmFss027wggax6bkT9Hp6Q4v/weSyMev44VhewAAAABJRU5ErkJggg=="
                    />
                </div>
            </transition>
            <!-- <h4>Work with a licensed agent to quickly compare quotes from top-rated insurers.</h4> -->
            <div v-if="InsurenceResult">
                <div
                    v-for="(item, index) in InsurenceResult"
                    :key="index">
                    <div class="insurers-details">
                        <div class="row">
                            <div class="col-sm-3 insurers-ratings">
                                <div class="partner-logo">
                                    <img
                                        :src="item.lender.logoUrl"
                                        alt="insurers-logo"
                                    />
                                </div>
                                <div
                                    v-if="item.lender.review && item.lender.review.result && lenderReviewCount(item)"
                                    class="star-rating-section">
                                    <div class="rating-star">
                                        <div
                                            class="rating-stars-top"
                                            :style="{'width':lenderPercentOverallRating((item.lender.review.result.statistics != null) ?
                                                item.lender.review.result.statistics.averageOverallRating : 0) }">
                                            <span class="lt-icons lt4-Star"></span>
                                            <span class="lt-icons lt4-Star"></span>
                                            <span class="lt-icons lt4-Star"></span>
                                            <span class="lt-icons lt4-Star"></span>
                                            <span class="lt-icons lt4-Star"></span>
                                        </div>
                                        <div class="rating-stars-bottom">
                                            <span class="lt-icons lt4-Star"></span>
                                            <span class="lt-icons lt4-Star"></span>
                                            <span class="lt-icons lt4-Star"></span>
                                            <span class="lt-icons lt4-Star"></span>
                                            <span class="lt-icons lt4-Star"></span>
                                        </div>
                                    </div>
                                    <div class="ratingsLink">
                                        <review-link
                                            :content-key-for-reviews="item.lender.reviewId"
                                            :review-count="reviewCount(item)"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-6 about-insurers">
                                <h5> {{ item.lender.name }}</h5>
                                <p>{{ item.placement.header }}</p>
                                <ul id="s">
                                    <li
                                        v-for="(bullets, bulletsIndex) in item.placement.marketingBullets"
                                        :key="bulletsIndex">
                                        {{ bullets }}
                                    </li>
                                </ul>
                            </div>
                            <div class="col-sm-3 insurers-contacts">
                                <div v-if="item.placement.phoneNo">
                                    <span class="lt4-MobilePhone"></span>
                                    <a
                                        :href="'tel:' + item.placement.phoneNo"
                                        class="contact-number">{{ item.placement.phoneNo }}</a>
                                    <p>Speak with an agent</p>
                                </div>
                                <a
                                    :data-href="item.placement.destinationUrl"
                                    class="btn btn-blue"
                                    @click="insurerClicked(item.lender.lendingEntityId, item.placement.destinationUrl, item.lender.name, item.lender.logoUrl)">{{ item.placement.ctaText ? item.placement.ctaText : 'Visit Site' }}</a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ZipCodeInput from '~/components/zip-code-input.vue';
    import GetLocation from '~/mixin/get-geo-location';
    import SessionIdHelper from '~/helpers/uuid-service';
    import QueryStringHelper from '~/helpers/query-string-helper';
    import TrackDataHelper from '~/helpers/track-data-helper';
    import AnalyticsTrack from '~/mixin/analytics-track';
    import AnalyticsHelper from '~/helpers/analytics';
    import appStorage from '~/helpers/app-storage';
    import {
        postPrePrimeLead, postPrePrimeRefferal, getPrePrimeDetails, getCSLeadTrackingId,
    } from '~/services/preprime-api';
    import ReviewLink from '~/components/review-link.vue';
    import ReviewCount from '~/mixin/review-count';

    export default {
        components: {
            ZipCodeInput,
            ReviewLink,
        },
        mixins: [AnalyticsTrack, GetLocation, ReviewCount],
        props: {
            zipCode: {
                default: 28277,
            },
            showLoader: {
                default: false,
            },
            zipcodeLabel: {
                default: 'Zip Code',
            },
            insuredLabel: {
                default: 'Currently Insured?',
            },
            insuranceTypeLabel: {
                default: 'Insurance Type',
            },
            currentlyInsured: {
                default: 'Yes',
            },
            popupSubmit: {
                default: 'false',
            },
            city: {
                default: '',
            },
            state: {
                default: '',
            },
        },
        data() {
            return {
                ZipCode: this.zipCode,
                ShowLoader: this.showLoader,
                CurrentlyInsured: this.currentlyInsured,
                ProductType: 'home',
                InsuranceType: 'home insurance',
                InsuranceTypeDisplayName: 'Home Insurance  Only',
                BundleType: 'auto insurance',
                BundleDisplayName: 'Bundle',
                IsBundleSelected: false,
                InsurenceResult: {},
                ShowZipCodeError: false,
                SessionId: '',
                Vertical: 'home insurance',
                Placement: 'www-results-insurance',
                isFormChanged: true,
                LeadGuid: null,
                City: this.city,
                State: this.state,
                ClickId: '',
                formData: { },
            };
        },
        watch: {
            currentlyInsured() {
                this.CurrentlyInsured = this.currentlyInsured;
            },
            zipCode() {
                this.ZipCode = this.zipCode;
            },
            city() {
                this.City = this.city;
            },
            state() {
                this.State = this.state;
            },
            popupSubmit() {
                this.updateFormData();
                this.insuranceGetResultClicked();
                this.fetchInsuranceResult();
            },
        },
        created() {
            this.updateInsuranceType();
        },
        methods: {
            lenderPercentOverallRating(rating) {
                return rating != null ? `${rating / 5.0 * 100.0}%` : 0;
            },
            lenderReviewCount(item) {
                try {
                    return item.lender.review.result.statistics.reviewCount;
                } catch (e) {
                    console.warn(e);
                    return 0;
                }
            },
            updateResults(result) {
                this.updateFormData();
                this.InsurenceResult = result;
                this.ShowLoader = false;
            },
            updateInsuranceType() {
                let productType = QueryStringHelper.getQueryStringParam('productType');
                if (productType) {
                    productType = productType.toLowerCase().trim();
                    switch (productType) {
                        case 'auto':
                            this.Vertical = 'auto insurance';
                            this.InsuranceType = 'auto insurance';
                            this.ProductType = 'auto';
                            this.InsuranceTypeDisplayName = 'Auto Insurance Only';
                            this.BundleType = 'home insurance';
                            break;
                        case 'life':
                            this.Vertical = 'life insurance';
                            this.InsuranceType = 'life insurance';
                            this.ProductType = 'life';
                            this.InsuranceTypeDisplayName = 'Life Insurance Only';
                            this.BundleType = 'home insurance';
                            break;
                        case 'bundle':
                        case 'home':
                        default:
                            this.Vertical = 'home insurance';
                            this.InsuranceType = 'home insurance';
                            this.InsuranceTypeDisplayName = 'Home Insurance Only';
                            this.BundleType = 'auto insurance';
                            if (productType === 'bundle') {
                                this.IsBundleSelected = true;
                                this.ProductType = 'bundle';
                            } else {
                                this.IsBundleSelected = false;
                                this.ProductType = 'home';
                            }
                            break;
                    }
                }
            },
            fetchInsuranceResult() {
                this.ProductType = this.getInsuranceType();
                this.ShowLoader = true;
                this.makePrePrimeLeadCall();
                const data = {
                    fullzip: this.ZipCode,
                    isCurrentlyInsured: this.CurrentlyInsured,
                    vertical: this.InsuranceType,
                    bundleType: this.IsBundleSelected ? this.BundleType : undefined,
                    placement: this.Placement,
                };
                getPrePrimeDetails(this.updateResults, 'insurance', data);
            },
            makePrePrimeLeadCall() {
                const storageKey = 'home-insurance-lead';
                const expiration = 60 * 60 * 1000;
                const dataFromStore = appStorage.get(storageKey);
                const insuranceType = this.getInsuranceType();
                if (dataFromStore) {
                    if (dataFromStore.ZipCode === this.ZipCode && dataFromStore.CurrentlyInsured === this.CurrentlyInsured && dataFromStore.InsuranceType === insuranceType) {
                        this.LeadGuid = dataFromStore.LeadGuid;
                        return;
                    }
                }
                this.LeadGuid = SessionIdHelper.generateGuid();
                const data = {
                    zipCode: this.ZipCode,
                    vertical: this.Vertical,
                    placement: this.Placement,
                    guid: this.LeadGuid,
                    city: this.City,
                    state: this.State,
                    isCurrentlyInsured: this.CurrentlyInsured,
                    insuranceType,
                    product: this.ProductType,
                };
                appStorage.set(storageKey, {
                    ZipCode: this.ZipCode, CurrentlyInsured: this.CurrentlyInsured, InsuranceType: insuranceType, LeadGuid: this.LeadGuid,
                }, expiration);
                postPrePrimeLead(data);
            },
            getInsuranceType() {
                return this.IsBundleSelected
                    ? 'bundle'
                    : this.InsuranceType === 'home insurance'
                        ? 'home'
                        : this.InsuranceType === 'auto insurance'
                            ? 'auto'
                            : this.InsuranceType === 'life insurance'
                                ? 'life'
                                : '';
            },
            getLocationByZip() {
                this.ShowZipCodeError = false;
                this.ZipError = false;
                if (this.zipCodeValidator()) {
                    GetLocation.methods.GetZipCode(this.ZipCode, this.updateLocation);
                }
            },
            updateLocation(val) {
                this.ZipCode = val.zipCode;
                this.ZipError = val.err;
                if (this.ZipError) {
                    this.ShowZipCodeError = true;
                    this.ZipCode = '';
                } else {
                    this.ShowZipCodeError = false;
                    this.City = val.city;
                    this.State = val.state;
                }
            },
            zipCodeValidator() {
                const zipRegEx = /^\d{5}$/;
                const testZip = zipRegEx.test(this.ZipCode) && this.ZipCode !== '';
                return testZip && !this.ZipError;
            },
            insurerClicked(lendingEntityId, destinationUrl, vendorName, vendorLogoUrl) {
                this.SessionId = SessionIdHelper.generateGuid();
                this.ClickId = this.SessionId;
                TrackDataHelper.setMany(this.trackInsurerClick(this.IsBundleSelected), 'InsurerClicked');
                AnalyticsHelper.track('Insurance Ad Clicked', TrackDataHelper.get('InsurerClicked'));

                TrackDataHelper.setMany(this.trackInsurerCheckout(), 'InsurerCheckout');
                AnalyticsHelper.track('Checkout Started', TrackDataHelper.get('InsurerCheckout'));
                const tokenValues = {
                    clickId: this.ClickId,
                    zipCode: this.ZipCode,
                    currentlyInsured: this.CurrentlyInsured.toLowerCase(),
                    qFormId: this.LeadGuid,
                };
                const partnerURL = SessionIdHelper.tokenReplacement(SessionIdHelper.getTokenList(destinationUrl, tokenValues), destinationUrl);
                const data = {
                    lendingEntityId,
                    formId: this.LeadGuid,
                    sid: this.SessionId,
                    placement: this.Placement,
                    destinationUrl: partnerURL,
                    partnername: vendorName,
                    partnerlogo: vendorLogoUrl,
                    partnerurl: partnerURL,
                };
                // SUB:4223: Add csleadId in destinationUrl
                if (this.LeadGuid) {
                    const storageKey = 'debt-relief-formId';
                    const dataFromStore = appStorage.get(storageKey);
                    if (dataFromStore && dataFromStore.qFormId === this.LeadGuid && dataFromStore.csLeadId) {
                        this.SuccessCallback(data, dataFromStore.csLeadId);
                    } else {
                        getCSLeadTrackingId((result) => {
                            if (!isNaN(result)) {
                                const expiration = 60 * 60 * 1000;
                                appStorage.set(storageKey, { qFormId: this.LeadGuid, csLeadId: result }, expiration);
                                this.SuccessCallback(data, result);
                            } else {
                                postPrePrimeRefferal(data, 'referral');
                            }
                        }, { formId: this.LeadGuid });
                    }
                } else {
                    postPrePrimeRefferal(data, 'referral');
                }
            },
            SuccessCallback(postData, result) {
                if (result) {
                    postData.partnerurl = SessionIdHelper.matchToken('{CSLeadID}', result, postData.partnerurl);
                    postData.destinationUrl = postData.partnerurl;
                }
                postPrePrimeRefferal(postData, 'referral');
            },
            insuranceGetResultClicked() {
                this.SessionId = SessionIdHelper.generateGuid();
                TrackDataHelper.setMany(this.trackInsurerClick(this.IsBundleSelected), 'InsuranceGetResultClicked');
                AnalyticsHelper.track('Insurance Form Started', TrackDataHelper.get('InsuranceGetResultClicked'));
            },
            updateFormData() {
                this.formData = {
                    ZipCode: this.ZipCode,
                    State: this.State,
                    City: this.City,
                    IsCurrentlyInsured: this.CurrentlyInsured,
                    ProductType: this.ProductType,
                    IsBundleSelected: this.IsBundleSelected,
                    OtherVertical: this.IsBundleSelected ? this.BundleType : '',
                };
            },
        },
    };
</script>

<style lang="scss">
@import "../../../assets/styles/variables";

    #lt-yantr {
        .insurance-filter {
            background: #d4eee7;
            padding: 20px;

            label {
                color: #101f30;
                font-weight: 600;

                @media #{$mob-landscape-view} {
                    margin-top: 15px;
                }
            }

            .row .col-sm-2:first-child label {
                @media #{$mob-landscape-view} {
                    margin-top: 0;
                }
            }

            input[type="text"] {
                height: 40px;
                line-height: 40px;
                margin-bottom: 0;

                @media #{$mob-landscape-view} {
                    max-width: 150px;
                    display: block;
                }
            }

            .form-radio {
                li {
                    display: inline-block;

                    @media #{$mob-landscape-view} {
                        display: block;
                    }

                    &:first-child {
                        margin-right: 20px;

                        @media #{$mob-landscape-view} {
                            margin-right: 0;
                        }
                    }
                }
            }

            button {
                margin-top: 13px;

                @media #{$mob-landscape-view} {
                    margin-top: 25px;
                }
            }
        }

        .insurance-results {
            position: relative;

            .loader {
                background: rgba(255, 255, 255, 0.8);

                img {
                    margin-top: 150px;
                }
            }

            & > h4 {
                font-weight: 400;
                margin-top: 20px;
            }

            .insurers-ratings {
                .partner-logo {
                    img {
                        max-width: 200px;
                        max-height: 110px;
                        margin-bottom: 30px;

                        @media #{$mob-landscape-view} {
                            margin-bottom: 20px;
                        }
                    }
                }
            }
        }

        .insurers-details {
            background: #fff;
            box-shadow: 0 1px 2px rgba(0, 0, 0, .3);
            padding: 25px 40px;
            margin-top: 20px;

            @media #{$iPad-landscape-view} {
                padding: 20px;
            }

            .insurers-ratings {
                @media #{$mob-landscape-view} {
                    text-align: center;
                }
                p {
                    margin: 20px 0 5px;

                    span {
                        color: #08c177;
                        font-weight: 600;
                    }
                }
            }

            .rating-count {
                display: inline-block;
                color: #000;
                padding-left: 3px;

                a {
                    font-size: 12px;
                }
            }

            .about-insurers {
                @media #{$mob-landscape-view} {
                    margin-top: 20px;
                }

                h5 {
                    text-transform: inherit;
                    margin-bottom: 10px;
                }

                p {
                    margin-bottom: 15px;
                }

                ul {
                    font-size: 15px;
                    margin-left: 17px;

                    li {
                        line-height: normal;
                        list-style-type: disc;
                        margin-bottom: 10px;
                    }
                }
            }

            .insurers-contacts {
                text-align: right;

                @media #{$mob-landscape-view} {
                    text-align: center;
                    margin-top: 20px;
                }

                & > span {
                    font-size: 15px;
                    padding-right: 2px;
                }

                .contact-number {
                    font-size: 20px;
                    font-weight: 600;
                    margin-bottom: 5px;
                    display: inline-block;

                    @media #{$tab-portrait-view} {
                        font-size: 18px;
                    }
                }

                p {
                    color: #101f30;

                    @media #{$tab-portrait-view} {
                        font-size: 13px;
                    }
                }

                .btn {
                    font-size: 14px;
                    padding: 5px 18px;
                    width: 145px;

                    @media #{$mob-landscape-view} {
                        display: inline-block;
                        width: 180px;
                    }
                }
            }
        }
    }
</style>
